import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';
import GoogleRatingBadge from '@/components/GoogleRatingBadge';
import { BUSINESS } from '@/lib/site';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, FaxIcon } from '@/components/icons';

export default function SiteFooter() {
  return (
    <footer className="bg-[#060D9C] text-white" data-testid="site-footer">
      <div className="hi-vis-stripe h-1.5" aria-hidden="true" />
      <div className="nft-container py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Logo variant="dark" />
            <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-xs">
              New Zealand's most trusted forklift training specialists.
              Friendly, efficient and the best possible service — since 1990.
            </p>
            <div className="mt-4">
              <GoogleRatingBadge dark={false} />
            </div>
          </div>

          <div>
            <div className="label-eyebrow text-[#FC4E2C] mb-3">Courses</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/courses/standard" className="text-white/80 hover:text-[#FC4E2C]">Standard / Renewal</Link></li>
              <li><Link to="/courses/beginner" className="text-white/80 hover:text-[#FC4E2C]">Beginner Course</Link></li>
              <li><Link to="/courses/f-endorsement" className="text-white/80 hover:text-[#FC4E2C]">“F” Endorsement</Link></li>
              <li><Link to="/courses/nzqa" className="text-white/80 hover:text-[#FC4E2C]">NZQA Unit Standards</Link></li>
              <li><Link to="/courses" className="text-white/80 hover:text-[#FC4E2C]">All Services</Link></li>
            </ul>
          </div>

          <div>
            <div className="label-eyebrow text-[#FC4E2C] mb-3">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-white/80 hover:text-[#FC4E2C]">About Us</Link></li>
              <li><Link to="/location" className="text-white/80 hover:text-[#FC4E2C]">Location & Hours</Link></li>
              <li><Link to="/booking" className="text-white/80 hover:text-[#FC4E2C]">Book / Enquire</Link></li>
              <li><a href={BUSINESS.phoneHref} className="text-white/80 hover:text-[#FC4E2C]">Call us</a></li>
            </ul>
          </div>

          <div>
            <div className="label-eyebrow text-[#FC4E2C] mb-3">Contact</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPinIcon width={18} height={18} className="shrink-0 mt-0.5 text-[#FC4E2C]" />
                <span className="text-white/85">
                  {BUSINESS.address.line1}<br />
                  {BUSINESS.address.line2}<br />
                  {BUSINESS.address.city} {BUSINESS.address.postcode}
                </span>
              </li>
              <li className="flex items-center gap-2">
                <PhoneIcon width={18} height={18} className="shrink-0 text-[#FC4E2C]" />
                <a href={BUSINESS.phoneHref} className="text-white/85 hover:text-[#FC4E2C]">{BUSINESS.phone}</a>
              </li>
              <li className="flex items-center gap-2">
                <FaxIcon width={18} height={18} className="shrink-0 text-[#FC4E2C]" />
                <span className="text-white/85">{BUSINESS.fax}</span>
              </li>
              <li className="flex items-center gap-2">
                <MailIcon width={18} height={18} className="shrink-0 text-[#FC4E2C]" />
                <a href={BUSINESS.emailHref} className="text-white/85 hover:text-[#FC4E2C] break-all">{BUSINESS.email}</a>
              </li>
              <li className="flex items-center gap-2">
                <ClockIcon width={18} height={18} className="shrink-0 text-[#FC4E2C]" />
                <span className="text-white/85">{BUSINESS.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</div>
          <div className="label-eyebrow">100% NZ Owned · WorkSafeNZ Approved · Audited by Competenz</div>
        </div>
      </div>
    </footer>
  );
}
